export const WORLD_W = 1600;
export const WORLD_H = 900;
/** Cokoli pod touto čarou se utopí. */
export const WATER_Y = 868;

export const GRAVITY = 420; // px/s²
export const MAX_SPEED = 950; // px/s při síle 100
export const WIND_ACCEL = 1.3; // px/s² na jednotku větru
export const MAX_WIND = 70;

export const SIM_DT = 1 / 240;
export const FRAME_RATE = 60;
/** Každý kolikátý krok simulace se ukládá bod trajektorie (240 / 4 = 60 fps). */
export const FRAME_EVERY = 4;
export const MAX_SHOT_TIME = 16;

export const MAX_HP = 100;
export const FUEL = 120; // pixelů jízdy na tah
export const WALK_SPEED = 80; // px/s – jen pro animaci
export const CLIMB = 5; // max. výška schodu při jízdě
export const TANK_HIT_R = 11;
/** Střed tanku leží tolik pixelů nad bodem, kde tank stojí. */
export const TANK_CENTER_DY = 6;
export const BARREL_LEN = 14;
/** Rozsah úhlu hlavně: 0 = doprava, 90 = nahoru, 180 = doleva; pod 0 / nad 180 míří šikmo dolů. */
export const MIN_ANGLE = -60;
export const MAX_ANGLE = 240;
export const FALL_SAFE = 40;
export const FALL_DMG_PER_PX = 0.4;
export const FALL_DURATION = 0.6;

export const TANK_COLORS = [
  '#e74c3c',
  '#3498db',
  '#f1c40f',
  '#2ecc71',
  '#9b59b6',
  '#e67e22',
  '#1abc9c',
  '#ecf0f1',
];

export const TURN_LIMITS = [30, 60, 120, 600, 3600, 12 * 3600, 24 * 3600, 48 * 3600];
export const MAX_PLAYERS = 8;

// Deathmatch v reálném čase
/** Přebíjení po výstřelu (ms). */
export const DM_RELOAD_MS = 3000;
/** Dobíjení paliva (px/s); maximum je FUEL. */
export const DM_FUEL_REGEN = 20;
/** Pojistka proti nekonečné hře (AFK hráči s municí). */
export const DM_TIME_LIMIT_MS = 10 * 60 * 1000;
/** Jak často se mění vítr (ms). */
export const DM_WIND_PERIOD_MS = 20_000;
/** Náskok na začátku, než jde vystřelit poprvé (ms). */
export const DM_START_GRACE_MS = 3000;
/** Základní střely v deathmatchi (jinak jsou nekonečné). */
export const DM_SHELLS = 15;

// Sesuv půdy po výbuchu
/** Maximální výškový rozdíl sousedních sloupců, který ještě drží (3 : 1 ≈ 70°). */
export const REPOSE = 3;
export const SLIDE_MARGIN = 24;
export const SLIDE_UP = 120;
export const SLIDE_PASSES = 400;
export const SLIDE_MAX_MOVES = 20000;
/** Jak dlouho se animují padající zrnka (s). */
export const SLIDE_ANIM = 0.8;
/** Převis drží, jen když je nad ním aspoň tolik pevných px (klenba / strop jeskyně). */
export const OVERHANG_THICK = 24;

/** Polovina tloušťky terénu ve 3D – mimo tento „plát“ (|z|) se do terénu nenarazí. */
export const DEPTH_SLAB = 60;
/** Jak daleko do stran z plátu smí drony vyletět. */
export const DRONE_MAX_Z = 420;
